import { render, staticRenderFns } from "./Travel_add.vue?vue&type=template&id=23747206&scoped=true&"
import script from "./Travel_add.vue?vue&type=script&lang=js&"
export * from "./Travel_add.vue?vue&type=script&lang=js&"
import style0 from "./Travel_add.vue?vue&type=style&index=0&id=23747206&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23747206",
  null
  
)

export default component.exports